import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { bothRequired } from '../../../../../../common/forms/custom.validators';

export interface RoadOccupationStagePurposeFeeItemFormValue {
  width: string | number;
  length: string | number;
  area: string | number;
  quantity?: string | number;
  name: string;
  feeId: string;
  rateId: string;
}

export class RoadOccupationStagePurposeFeeItemForm extends AppForm {
  constructor() {
    super({
      width: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      length: new FormControl('', {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      }),
      area: new FormControl(
        { value: '', disabled: true },
        {
          validators: [Validators.maxLength(255)],
          nonNullable: true
        }
      ),
      name: new FormControl('', { nonNullable: true }),
      feeId: new FormControl('', { nonNullable: true }),
      rateId: new FormControl('', { nonNullable: true })
    }, {
      validators: [bothRequired('width', 'length')]
    });
  }

  public createQuantityControl(): void {
    this.addControl(
      'quantity',
      new FormControl(null, {
        validators: [Validators.maxLength(255)],
        nonNullable: true
      })
    );
  }

  public get quantity(): FormControl | null {
    return this.get('quantity') as FormControl | null;
  }

  public get width(): FormControl {
    return this.get('width') as FormControl;
  }

  public get length(): FormControl {
    return this.get('length') as FormControl;
  }

  public get area(): FormControl {
    return this.get('area') as FormControl;
  }

  public get name(): FormControl {
    return this.get('name') as FormControl;
  }

  public get feeId(): FormControl {
    return this.get('feeId') as FormControl;
  }

  public get rateId(): FormControl {
    return this.get('rateId') as FormControl;
  }

  public calcArea(multiple: boolean = false): void {

    const quantity = this.quantity?.value ? +this.quantity?.value : 1;

    let width = `${this.width.value}`;
    let length = `${this.length.value}`;
    if (!width || !length) {
      return;
    }
    width = (width || '0').replaceAll(',', '.').replaceAll(' ', '');
    length = (length || '0').replaceAll(',', '.').replaceAll(' ', '');

    const area = Number(width) * Number(length);
    this.area.setValue(((multiple ? area * 2 : area) * quantity).toFixed(2).replaceAll('.', ','));
  }

  public canClearControls(): boolean {
    return this.width.value || this.length.value || this.area.value || this.quantity?.value;
  }

  public clearControls(): void {
    this.width.setValue('', { emitEvent: false });
    this.length.setValue('', { emitEvent: false });
    this.area.setValue('', { emitEvent: false });
    this.quantity?.setValue('', { emitEvent: false });
  }

  public get values(): RoadOccupationStagePurposeFeeItemFormValue {
    return {
      area: this.area.value,
      width: this.width.value,
      length: this.length.value,
      name: this.name.value,
      feeId: this.feeId.value,
      rateId: this.rateId.value,
      quantity: this.quantity?.value ? +this.quantity?.value : undefined
    };
  }
}
